import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { Http, Response, ResponseType, RequestOptions, ResponseContentType, Headers } from '@angular/http';
import { Router } from '@angular/router';
//import {UserService} from '../user/user.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { FileUploader } from 'ng2-file-upload';

@Injectable()
export class ApiService {
  ROOT_URL: string = "";
  constructor(
    private http: Http,
    //private user:UserService,
    private router: Router,
  ) {
    this.getConfigValue("urlRoot").subscribe(res => {
      this.ROOT_URL = res;
    });
  }

  public Excute(apiURL, params: any, options = null): Observable<any> {
    if (localStorage.getItem("UserInfo") == null || localStorage.getItem("UserInfo") == undefined) {
      this.router.navigate(['/pages/login']);
    }
    return this.http
    .post(this.ROOT_URL + apiURL, params, options)
    .map(res => {
           return res.json();
    });
  }

  public async ExcuteNoneAsync(apiURL, params: any, options = null): Promise<any> {
    if (localStorage.getItem("UserInfo") == null || localStorage.getItem("UserInfo") == undefined) {
      this.router.navigate(['/pages/login']);
    }

    const response = await this.http.post(this.ROOT_URL + apiURL, params, options).toPromise();
    return response.json();
  }


  public downloadFile(apiURL, params: any, filename: any): Observable<any> {

    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(this.ROOT_URL + apiURL, params, options)
      .map(res => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
          var a = document.createElement('a');
          var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          let blob = new Blob([res.blob()], { type: contentType });
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          var a = document.createElement('a');
          var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          let blob = new Blob([res.blob()], { type: contentType });
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 100);
        }


      });
  }
  public uploadMutiFile(apiURL, desFolder: string, overWrite: string, file: File): Observable<any> {
    debugger
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    debugger
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.ROOT_URL + apiURL, formData, options)
      .map(res => res.json())
  }
  public uploadFile(apiURL, desFolder: string, overWrite: string, fileList: FileList): Observable<any> {
    debugger
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      formData.append('Desfolder', desFolder);
      formData.append('overWrite', overWrite);
      let headers = new Headers()
      //headers.append('Content-Type', 'json');  
      //headers.append('Accept', 'application/json');  
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.ROOT_URL + apiURL, formData, options)
        .map(res => res.json())
    }
  }

  public uploadNhatKyVanHanh(file: File): Observable<any> {
    debugger
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.ROOT_URL + "api/NhatKyVanHanh", formData, options)
      .map(res => res.json())
  }

  public exportExcel(data, cols, para, config, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan = "") {
    let dateNow = new Date();
    let strDate = "";
    if (thoidiemtruyvan != "") {
      strDate = thoidiemtruyvan;
    }
    else {
      strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    }
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: strDate,
      filename: fileName,
      sheets: tenchucnang,
      columns: cols,
      data: data
    };
    return this.downloadFile("api/ExportExcel", param, fileName);
  }

  public saveExcel(data, cols, para, config, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan = "", danhmucid, tenbaocao, loaibaocao) {

    let dateNow = new Date();
    let strDate = "";
    if (thoidiemtruyvan != "") {
      strDate = thoidiemtruyvan;
    }
    else {
      strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    }
    let currentUser = JSON.parse(localStorage.getItem("UserInfo"));
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: strDate,
      filename: fileName,
      sheets: tenchucnang,
      columns: cols,
      data: data,
      mataikhoan: currentUser.mataikhoan,
      danhmucid: danhmucid,
      tenbaocao: tenbaocao,
      loaibaocao: loaibaocao
    };
    return this.Excute("api/SaveExcel", param, fileName);
  }
  public uploadFile_CMIS(apiURL, desFolder: string, overWrite: string, file: File): Observable<any> {
    if (file.size > 0) {
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      formData.append('Desfolder', desFolder);
      formData.append('overWrite', overWrite);
      let headers = new Headers()
      //headers.append('Content-Type', 'json');  
      //headers.append('Accept', 'application/json');  
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.ROOT_URL + apiURL, formData, options)
        .map(res => res.json())
    }
  }
  public getConfigValue(key) {
    return this.http.get('../assets/config/config.json')
      .map((data) => {
        let element_ret: any;
        data.json().forEach(element => {
          if (element.key == key) {
            element_ret = element;
          }
        });
        return element_ret.value;
      });
  }
  public getLinkTemp(api_link) {
    return this.ROOT_URL + api_link;
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/api.service.ts